module.exports = __webpack_public_path__ + "favicons__evo/favicons.webpackcruft";


//////////////////
// WEBPACK FOOTER
// ./client/src/site__evo/favicons/html_code.html
// module id = D:\a\1\s\node_modules\file-loader\dist\cjs.js??ref--5-0!D:\a\1\s\node_modules\extract-loader\lib\extractLoader.js!D:\a\1\s\node_modules\html-loader\index.js??ref--5-2!D:\a\1\s\client\src\site__evo\favicons\html_code.html
// module chunks = site__evo